// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3aB-h","title":"Header_title__3w866","side":"Header_side__211w2"};